import { SVGElementType } from "../../core/helpers/svg-functions";

export abstract class Panel {
  constructor(protected x: number, protected y: number, protected width: number, protected height: number) {}
  abstract drawCutout(): SVGElementType;
}
